export const curationsApiPath = {
  getCurationsMe: '/v2/curations/me',
  /** 큐레이터 본인 업로드 스냅 목록 (큐레이션 생성 시 선택용, MUSINSA 전용) */
  getMySnaps: '/v2/curations/snaps',
  getCurationSnaps: (curationId: string) => `/v2/curations/${curationId}/snaps`,
  getCurations: '/v2/curations',
  getCuration: (curationId: number | string) => `/v2/curations/${curationId}`,
  postCurations: '/v2/curations',
  putCurations: (curationId: number | string) => `/v2/curations/${curationId}`,
  postProductLike: '/v2/products/like',
  getCurationsOrderList: '/v2/curations/order-list',
  putCurationsOrder: '/v2/curations/order',
  deleteCuration: (curationId: string) => `/v2/curations/${curationId}`,
  getCurationsCheckLimit: '/v2/curations/check-limit',
  getCurationTabsVisibility: '/v2/curations/tabs/visibility',
} as const;
